<p
  *ngIf="item?.month"
  class="date-divider">
  {{ "DATEPICKER." + item?.month | translate }}
  {{ getYear(item!.creation_date) }}
</p>

<div
  *ngIf="item"
  (click)="readNotificaiton(item)"
  [ngClass]="{
    'high': item.priority === 1,
    'medium': item.priority === 2,
    'low': item.priority === 3,
    'selected': isItemSelected
  }"
  class="notification-item">
  <div class="notification-item__head">
    <div class="notification-item__head-left">
      <button
        [class.readed]="item.is_notification_read"
        class="btn-icon">
        <img
          *ngIf="!item.is_notification_read"
          src="assets/img/unread-icon.svg"
          class="btn-icon__image" />
        <img
          *ngIf="item.is_notification_read"
          src="assets/img/read-icon.svg"
          class="btn-icon__image" />
      </button>

      <button
        (click)="openDeleteItemDialog(item.id, $event)"
        class="btn-icon">
        <img
          src="assets/img/delete.svg"
          alt="Delete icon"
          class="btn-icon__image" />
      </button>
    </div>

    <div class="notification-item__head-right">
      <div
        [ngClass]="{
          'high': item.priority === 1,
          'medium': item.priority === 2,
          'low': item.priority === 3
        }"
        class="notification-status">
        <img
          *ngIf="item.priority === 1"
          src="assets/img/notification-type-1.svg"
          alt="Notification type"
          class="icon" />
        <img
          *ngIf="item.priority === 2"
          src="assets/img/notification-type-3.svg"
          alt="Notification type"
          class="icon" />
        <img
          *ngIf="item.priority === 3"
          src="assets/img/notification-type-2.svg"
          alt="Notification type"
          class="icon" />
        <span>
          {{
            "NOTIFICATIONS_PAGE.NOTIFICATION_STATUS." + (item.priority === 1 ? "STATUS_HIGH" : item.priority === 2 ? "STATUS_MEDIUM" : "STATUS_LOW")
              | translate
          }}
        </span>
      </div>
    </div>
  </div>
  <h2 class="notification-item__headline">{{ item.notification_name }}</h2>
  <p
    [class.extended]="isItemSelected"
    class="notification-item__short">
    {{ item.notification_text }}
  </p>
  <div class="notification-item__footer">
    <div class="date-container">
      <img
        class="date-icon"
        src="assets/img/calendar.svg"
        alt="" />
      <p class="notification-item__date">{{ item.creation_date }}</p>
    </div>

    <div class="notification-type">
      <ng-container *ngIf="item.notification_relation === 2">
        <img
          src="assets/img/user.svg"
          alt="" />
        <span>
          {{ "NOTIFICATIONS_PAGE.NOTIFICATION_STATUS.PERSONAL" | translate }}
        </span>
      </ng-container>

      <ng-container *ngIf="item.notification_relation === 3">
        <img
          src="assets/img/users-icon.svg"
          alt="" />
        <span>
          {{ "NOTIFICATIONS_PAGE.NOTIFICATION_STATUS.COMMON" | translate }}
        </span>
      </ng-container>
    </div>
  </div>
</div>
